import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  Output
} from "@angular/core";
import { MedicalImageViewerService } from "src/app/services/medical-image-viewer.service";

@Directive({
  selector: "[medicalImageViewer]",
  standalone: false
})
export class MedicalImageViewerDirective implements AfterViewInit {
  @Input("medicalImageViewer") studyUuid!: string;

  @Input()
  storageId: string | undefined;

  @Input()
  tenantId: string | undefined;

  @Output()
  installed: EventEmitter<string> = new EventEmitter<string>();

  private readonly elementRef = inject(ElementRef<HTMLElement>);
  private readonly medicalImageViewerService = inject(
    MedicalImageViewerService
  );

  constructor() {}

  ngAfterViewInit(): void {
    this.medicalImageViewerService
      .install(
        this.studyUuid,
        this.storageId!,
        this.tenantId!,
        this.elementRef.nativeElement
      )
      .then((uuidRef) => {
        this.installed.emit(uuidRef);
      });
  }
}
